/**
 * The kiosk launch settings that travel onward: into the Sign-in QR a patron scans (and so onto the
 * patron's phone) and into the kiosk's undock URL, which is how they survive a session reset.
 * Nothing else from the launch URL - a patron's `code`, the `experienceList` lineup - may leave the
 * kiosk this way. Adding a key here is a deliberate decision, not a convenience.
 */
export const FORWARDED_KIOSK_SETTINGS = ['center', 'app', 'onboarding', 'defaultLanguage']

// Launch settings the kiosk itself persists (center and app have their own resolution and validation)
const PERSISTED_LAUNCH_SETTINGS = ['onboarding', 'defaultLanguage']

// Template-built URLs elsewhere can carry a literal `undefined`/`null`; treat those as missing too
export const hasValue = (value) => {
  const text = String(value ?? '').trim()
  return text !== '' && text !== 'undefined' && text !== 'null'
}

export function buildForwardedKioskParams(settings) {
  const params = new URLSearchParams()
  FORWARDED_KIOSK_SETTINGS.forEach((key) => {
    if (hasValue(settings?.[key])) params.set(key, settings[key])
  })
  return params
}

/**
 * The persisted launch settings (onboarding, defaultLanguage) for this page load: from the URL when
 * it is a launch URL (it names a center), otherwise from the cached kioskSettings. getKiosk stores
 * and the Sign-in QR reads through this one rule, so the undock URL and the QR can't drift apart.
 */
export function resolveKioskLaunchSettings(urlParams, cachedKioskSettings) {
  const source = urlParams?.center ? urlParams : cachedKioskSettings
  const settings = {}
  PERSISTED_LAUNCH_SETTINGS.forEach((key) => {
    if (hasValue(source?.[key])) settings[key] = source[key]
  })
  return settings
}
